module.exports = __webpack_public_path__ + "img/labscore.2c52f86d.png";